module.exports = __webpack_public_path__ + "img/symbol_7.29ce5832.png";